"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MathIndicator_exports = {};
__export(MathIndicator_exports, {
  default: () => MathIndicator_default
});
module.exports = __toCommonJS(MathIndicator_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.0547 5.25C14.2109 5.25 14.3477 5.30208 14.4648 5.40625C14.582 5.4974 14.6471 5.60807 14.6602 5.73828V5.79688V7.73047C14.6602 7.88672 14.6016 8.01693 14.4844 8.12109C14.3672 8.22526 14.224 8.27734 14.0547 8.27734C13.8984 8.27734 13.7617 8.23177 13.6445 8.14062C13.5273 8.04948 13.4622 7.93229 13.4492 7.78906V7.73047V6.36328H7.94141L10.8711 9.82031C10.9362 9.91146 10.9753 10.0156 10.9883 10.1328C11.0013 10.237 10.9753 10.3346 10.9102 10.4258L10.8711 10.4844L7.92188 14.1367H13.4492V12.7695C13.4492 12.6263 13.5013 12.5026 13.6055 12.3984C13.7096 12.2943 13.8333 12.2357 13.9766 12.2227H14.0547C14.2109 12.2227 14.3477 12.2682 14.4648 12.3594C14.582 12.4505 14.6471 12.5677 14.6602 12.7109V12.7695V14.7031C14.6602 14.8333 14.6081 14.957 14.5039 15.0742C14.3997 15.1784 14.276 15.237 14.1328 15.25H14.0547H7.19922C7.10807 15.25 7.01693 15.237 6.92578 15.2109C6.83464 15.1849 6.75651 15.1458 6.69141 15.0938C6.50911 14.9766 6.39193 14.8203 6.33984 14.625C6.30078 14.4297 6.33984 14.2474 6.45703 14.0781L6.49609 14.0195L9.62109 10.1719L6.51562 6.5C6.47656 6.44792 6.4375 6.38932 6.39844 6.32422C6.3724 6.25911 6.35938 6.1875 6.35938 6.10938L6.33984 6.03125C6.33984 5.82292 6.41146 5.64714 6.55469 5.50391C6.71094 5.36068 6.89974 5.27604 7.12109 5.25H7.19922H14.0547Z",
      fill: "currentColor"
    }
  )
);
const SvgMathIndicator = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MathIndicator_default = SvgMathIndicator;
